/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';
import parameters from './__generated__/BacklogMetaAPIConsumerWrapperQuery$parameters.ts';
import type { BacklogMetaAPIConsumerWrapperQuery } from './__generated__/BacklogMetaAPIConsumerWrapperQuery.graphql.ts';

type NextGenBacklogEntryPointComponent = EntryPointComponent<
	{
		backlogDataQuery: BacklogMetaAPIConsumerWrapperQuery;
	},
	{},
	{},
	{}
>;

export const nextGenBacklogEntryPoint: EntryPoint<
	NextGenBacklogEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<NextGenBacklogEntryPointComponent>(
		/* webpackChunkName: "async-next-gen-backlog-entrypoint" */ './BacklogWrapper.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: (entryPointRouteParams: EntryPointRouteParams) => {
		if (!fg('backlog-paginated-query')) {
			return {};
		}

		const { context, tenantContext } = entryPointRouteParams;

		const viewId = `ari:cloud:jira:${tenantContext.cloudId}:view/activation/${tenantContext.activationId}/board/${context.match.params.boardId}/backlog`;
		const rawQuickFilter = context.query?.quickFilter ?? context.query?.customFilter;
		const quickFilterIds = rawQuickFilter
			? String(rawQuickFilter).split(',').filter(Boolean).map(Number).filter(Number.isFinite)
			: undefined;

		const variables = {
			backlogViewInput: {
				jiraBacklogViewQueryInput: {
					viewId,
				},
			},
			view: {
				viewId,
			},
			...(quickFilterIds?.length ? { quickFilterIds } : {}),
		};

		return {
			queries: {
				backlogDataQuery: {
					parameters,
					variables,
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
